import Vue from "vue";
import ActionCableVue from "actioncable-vue";

Vue.use(ActionCableVue, {
  debug: true,
  debugLevel: "error",
  connectImmediately: true,
  connectionUrl: process.env.VUE_APP_ACTIONCABLE_CONNECTION_URL,
});
